import { render, staticRenderFns } from "./TermsAndConditionsAirveyEditions.vue?vue&type=template&id=fa5e685c&scoped=true&"
import script from "./TermsAndConditionsAirveyEditions.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsAirveyEditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5e685c",
  null
  
)

export default component.exports